import { RiFile2Line, RiAddFill } from "react-icons/ri";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { FormGroup, FormControl, Figure, Row, Col } from "react-bootstrap";
import { Formik, Form } from "formik";
import { IoMdOpen } from "react-icons/io";
import { MdClose, MdCheck } from "react-icons/md";

import { Settings } from "../../../helpers/Contexts";
import * as CONST from "../../../helpers/Constants";
import * as UTILS from "../../../helpers/Utility";

const EditCpr = ({ data }) => {
  const settings = useContext(Settings);
  const [editing, setEditing] = React.useState({
    cpr: false,
    document: false,
    order: false,
  });
  const [cpr, setCpr] = React.useState({
    status: data.status,
    sub_status: data.sub_status ? data.sub_status : "",
  });

  const handleSubmit = () => {
    let request = { id: data.taskId };
    if (
      cpr.status !== "closed" &&
      data.completed_on_date &&
      data.attending_provider &&
      (cpr.sub_status !== CONST.CPR.RESULTS_PENDING ||
        cpr.sub_status !== CONST.CPR.RESULTS_OBTAINED)
    ) {
      data.formHandler({
        task: {
          ...request,
          sub_status_list_id: cpr.sub_status
            ? UTILS.getSubStatusListId(cpr.sub_status, settings.all_sub_statuses)
            : null,
          cpr_type: cpr.status,
          completed_on_date: null,
          attending_provider: null,
        },
      });
    } else {
      data.formHandler({
        task: {
          ...request,
          sub_status_list_id: cpr.sub_status
            ? UTILS.getSubStatusListId(cpr.sub_status, settings.all_sub_statuses)
            : null,
          cpr_type: cpr.status,
        },
      });
    }
  };

  const SubmitCancelButtons = () => (
    <div className="check-cancel-buttons">
      <button className="check small" type="submit" onClick={() => handleSubmit()}>
        <MdCheck className="check-icon" />
      </button>
      <button className="cancel small" onClick={() => editing && setEditing(false)}>
        <MdClose className="cancel-icon" />
      </button>
    </div>
  );

  function renderEditCpr() {
    return (
      <>
        <div className="py1">
          <SubmitCancelButtons />
        </div>
        <div className="py1">
          Status:
          <select
            value={cpr.status}
            onChange={(e) => {
              setCpr({
                ...cpr,
                status: e.target.value,
                sub_status: e.target.value !== "closed" ? "" : "closed-cpr_not_required",
              });
            }}
          >
            {["confirmation", "reminder", "follow_up", "past_due", "closed"].map((i) => (
              <option key={i}>{i}</option>
            ))}
          </select>
        </div>
        <div className="py1">
          Substatus:
          <select
            value={cpr.sub_status}
            onChange={(e) => setCpr({ ...cpr, sub_status: e.target.value })}
          >
            {cpr.status == "closed" ? (
              CONST.CLOSED_SUB_STATUSES.map((i) => (
                <option key={i.value} value={i.value}>
                  {i.value}
                </option>
              ))
            ) : (
              <>
                <option value={"CPR required - resume notifications"}>
                  {"CPR required - resume notifications"}
                </option>
                <option value={""}>{"null"}</option>
              </>
            )}
          </select>
        </div>
      </>
    );
  }

  function renderUpload() {
    return (
      <Formik
        initialValues={editing.document ? { document: "" } : { order_document: "" }}
        onSubmit={(values) => {
          const formData = new FormData();
          formData.append("task[id]", data.taskId);
          editing.document
            ? formData.append("task[document]", values.document)
            : formData.append("task[order_document]", values.order_document);
          return data.formHandler(formData);
        }}
      >
        {({ values, setFieldValue, setTouched, errors }) => {
          return (
            <Form>
              <div className="check-cancel-buttons">
                <button className="check small" type="submit">
                  <MdCheck className="check-icon" />
                </button>
                <button className="cancel small" onClick={() => editing && setEditing(false)}>
                  <MdClose className="cancel-icon" />
                </button>
              </div>
              <p>{editing.document && "Attach new results document"}</p>
              {editing.order && "Attach new order document"}
              <FormGroup controlId="formFile" className="mb-3">
                <FormControl
                  type="file"
                  onChange={(e) =>
                    setFieldValue(
                      editing.document ? "document" : "order_document",
                      e.target.files[0]
                    )
                  }
                />
              </FormGroup>
            </Form>
          );
        }}
      </Formik>
    );
  }

  const Documents = () => (
    <div>
      <label>Documents</label>
      <Row className="mt10 ml0">
        <Col md={6} className=" no-gutters maxw40">
          {data.order_document.url ? (
            <Figure className="document">
              <Link
                to={{ pathname: data.order_document.url }}
                target="_blank"
                className="no-style"
                rel="noopener noreferrer"
              >
                <b>
                  {" "}
                  Order <IoMdOpen />
                </b>
                <p>{UTILS.FileNameFromUrl(data.order_document.url)}</p>
              </Link>
            </Figure>
          ) : (
            <Figure className="document-empty">
              <b>No Order Attached</b>
            </Figure>
          )}
          <a
            className={editing.order ? "disabled btn btn-default" : "btn btn-default"}
            onClick={(e) =>
              !editing.order && setEditing({ ...editing, document: false, order: true })
            }
          >
            {data.order_document.url ? "Replace Order ?" : <>Attach Order</>}
          </a>
        </Col>
        <Col md={6} className="no-gutters ml5 maxw40">
          {data.document.url ? (
            <Figure style={{ textAlign: "center" }}>
              <Link
                to={{ pathname: data.document.url }}
                target="_blank"
                className="no-style"
                rel="noopener noreferrer"
              >
                <RiFile2Line size={80} />
                <br />
                <b>
                  Results
                </b>
                <p>{UTILS.FileNameFromUrl(data.document.url).slice(0, 15) + "..."}</p>
              </Link>
            </Figure>
          ) : (
            <Figure className="document-empty">
              <RiFile2Line size={80} />
              <br />
              <b>No Results Attached</b>
            </Figure>
          )}{" "}
          <a
            className={editing.document ? "disabled btn btn-default" : "btn btn-default"}
            onClick={(e) =>
              !editing.document && setEditing({ ...editing, order: false, document: true })
            }
          >
            {data.document.url ? "Replace Results ?" : <>Attach Results</>}
          </a>{" "}
        </Col>
      </Row>
      {(editing.document || editing.order) && renderUpload()}
    </div>
  );

  return (
    <div>
      {!editing.cpr ? (
        <>
          Status: <b> {data.status} </b>
          <a className="ml5" onClick={() => !editing.cpr && setEditing({ ...editing, cpr: true })}>
            Edit
          </a>
          <br />
          Substatus:
          <b>
            <i> {data.sub_status} </i>
          </b>
        </>
      ) : (
        renderEditCpr()
      )}
      <br />
      Patient Response Status:
      <b>{data.cpr_type_response_status || " (None)"}</b>
      <br />
      Order Not Required Reason:
      <br />
      <b>{ data.order_not_available_reason || "(None)"}</b>
      <br />
      { data.verified_in_claims == true && (<>
          <i className='fa green-text fa-check-circle'></i>
          <b>Verified in Claims</b>
        </>)
      }
      <Documents />
    </div>
  );
};

export default EditCpr;
